import {
    AppBar,
    Card,
    Grid,
    Tab,
    Tabs,
    Typography,
    Box,
    Divider,
    TableHead,
    TableRow,
    TableCell,
    Table,
    TableBody,
    TextField,
    IconButton,
    Button,
    Tooltip
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import CustomerPersonal from './CustomerPersonal';
import customerApi from '../../api/customerApi';
import invoiceApi from '../../api/invoiceApi';
import practitionerApi from '../../api/practitionerApi';
import leadApi from '../../api/leadApi';
import styles from './styles';
import { toLocaleString } from '../../collums-components/helpers';
import GPDetails from './general/GPDetails';
import InsuranceDetails from './general/InsuranceDetails';
import KinOfEmergency from './general/KinOfEmergency';
import SavedCards from './general/SavedCards';
import CustomerMarketingData from './CustomerMarketingData';
import { Autocomplete } from '@material-ui/lab';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditableCell from '../../collums-components/components/common/InvoiceModal/EditableCell';
import { toastr } from 'react-redux-toastr';
import LoadingScreen from '../../collums-components/components/common/loadingScreen';
import CancelContinueModal from '../../collums-components/components/common/CancelContinueModal';
import CreateCustomerModal from '../../collums-components/components/common/CreateCustomerModal/CreateCustomerModal';
import { uploadCustomerAvatar } from '../../collums-components/api/CustomerApi';
import { LEAD_STATUS } from '../../collums-constants';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import moment from 'moment/moment';

class CustomerGeneral extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            group: 'personal',
            editGpAddress: false,
            editGpTel: false,
            editGpFax: false,
            editGpEmail: false,

            editInsuranceAddress: false,
            editInsuranceTel: false,
            editInsuranceFax: false,
            editInsuranceEmail: false,

            gp: {},
            insurance: {},
            customerOverall: {},
            customerLeadDetails: {},
            prevProps: props,
            lastUpdatedCustomerId: null,
            editServiceId: null,
            editValueId: null,
            editProductId: null,
            editProductValueId: null,
            editCourseId: null,
            editCourseValueId: null,
            servicesOptions: [],
            defaultServicesOptions: [],
            productsOptions: [],
            defaultProductsOptions: [],
            coursesOptions: [],
            defaultCoursesOptions: [],
            editOwner: false,
            editPipelineStage: false,
            owners: [],
            pipelineStages: [],
            leadState: {},
            isLoading: false,
            leadCustomer: null,
            isChangeLeadStatusConfirmModalOpen: false,
            isCreateCustomerConfirmModalOpen: false,
            isCreateClientFormOpen: false
        };
        this.handleChangeGp = this.handleChangeGp.bind(this);
        this.handleChangeInsurance = this.handleChangeInsurance.bind(this);
        this.saveGp = this.saveGp.bind(this);
        this.saveInsurance = this.saveInsurance.bind(this);
        this.saveCustomerLeadDetails = this.saveCustomerLeadDetails.bind(this);
    }

    static getDerivedStateFromProps(nextProps) {
        if (nextProps.customer) {
            return {
                gp: nextProps.customer.generalPractitioner,
                insurance: nextProps.customer.insurance,
                prevProps: nextProps
            };
        }

        return null;
    }

    async updateCustomerOverall(id) {
        if (this.state.lastUpdatedCustomerId === id) {
            return;
        }

        await customerApi.getCustomerOverall(id).then(res => {
            this.setState({
                customerOverall: res.data[0],
                lastUpdatedCustomerId: id
            });
        });
    }

    async updateCustomerLeadDetails(id) {
        if (this.state.lastUpdatedCustomerId === id) {
            return;
        }
        await customerApi.getCustomerLeadDetails(id).then(res => {
            this.setState({
                customerLeadDetails: res.data,
                lastUpdatedCustomerId: id
            });
        });
    }

    async componentDidMount() {
        await practitionerApi.listActivePractitioners().then(res => {
            const owners = res.map(el => ({ id: el.id, displayName: el.displayName }));
            owners.unshift({ id: null, displayName: 'Select staff' });
            this.setState({
                owners
            });
        });
        await customerApi.findCustomerByEmail(this.props.customer.email).then(res => {
            this.state.leadCustomer = res;
        });
        await leadApi.getStages().then(res => {
            this.setState({ pipelineStages: res });
        });
        await this.setState({
            group: this.props.route.params.group || 'personal'
        });
        await this.updateCustomerOverall(this.props.customer.id);
        if (this.props.customer.isLead) {
            await this.updateCustomerLeadDetails(this.props.customer.id);
        }
        await invoiceApi.getServices('', 50, false, true).then(res => {
            this.setState({
                defaultServicesOptions: res.items
            });
        });
        await invoiceApi.getProducts('', 50).then(res => {
            this.setState({
                defaultProductsOptions: res.items || res
            });
        });
        await invoiceApi.getCourses('', 50).then(res => {
            this.setState({
                defaultCoursesOptions: res
            });
        });
    }

    async componentDidUpdate(prevProps) {
        if (prevProps?.customer?.id !== this.props.customer.id) {
            await this.updateCustomerOverall(this.props.customer.id);
        }
        if (this.props.customer.isLead) {
            await this.updateCustomerLeadDetails(this.props.customer.id);
        }
    }

    renderRedirect() {
        if (this.state.redirect) {
            this.setState({ redirect: false });
            return <Redirect to={`/customer/${this.props.customer.id}/general/${this.state.group}`} />;
        }
    }

    handleChangeGp(e) {
        this.setState({
            gp: {
                ...this.state.gp,
                [e.target.name]: e.target.value
            }
        });
    }

    handleChangeInsurance(e) {
        this.setState({
            insurance: {
                ...this.state.insurance,
                [e.target.name]: e.target.value
            }
        });
    }

    async saveGp(context) {
        const newGp = await this.props.updateGp(this.props.customer.generalPractitioner.id, this.state.gp);
        this.setState({
            gp: newGp,
            [context]: false
        });
    }

    async saveInsurance(context) {
        const newInsurance = await this.props.updateInsurance(this.props.customer.insurance.id, this.state.insurance);
        this.setState({
            gp: newInsurance,
            [context]: false
        });
    }

    async saveCustomerLeadDetails() {
        this.setState({ isLoading: true });
        const leadServices = this.state?.customerLeadDetails?.leadServices || [];
        const leadProducts = this.state?.customerLeadDetails?.leadProducts || [];
        const leadCourses = this.state?.customerLeadDetails?.leadCourses || [];
        const data = {
            leadServices: leadServices.map(srv => ({
                service: srv.service.id,
                value: srv.value
            })),
            leadProducts: leadProducts.map(item => ({
                product: item.product.id,
                value: item.value
            })),
            leadCourses: leadCourses.map(item => ({
                course: item.course.id,
                value: item.value
            })),
            leadValue:
                leadServices.reduce((sum, s) => sum + (s.value || 0), 0) +
                leadProducts.reduce((sum, p) => sum + (p.value || 0), 0) +
                leadCourses.reduce((sum, c) => sum + (c.value || 0), 0),
            leadStage: this.state?.customerLeadDetails?.leadStage?.id,
            owner: this.state?.customerLeadDetails?.owner?.id || null
        };

        const updatedLead = await customerApi.updateCustomerLeadDetails(this.props.customer.id, data);
        if (updatedLead?.data?.id) {
            this.props.reloadCustomer(this.props.customer.id);
        }

        this.setState({ isLoading: false });
    }

    getTotalSpend() {
        // Live value calculated on the fly (same rules as the cron), reflects payments immediately
        if (typeof this.state.customerOverall?.liveTotalSpend === 'number') {
            return this.state.customerOverall.liveTotalSpend;
        }

        if (this.state.customerOverall?.totalsSpend) {
            if (Object.prototype.hasOwnProperty.call(this.state.customerOverall?.totalsSpend, 'totalSpend')) {
                return this.state.customerOverall?.totalsSpend.totalSpend;
            }
        }

        return 0;
    }

    render() {
        const { classes, infoHidden } = this.props;

        const getDataFormat = date => {
            if (!date) return;
            return date.format('DD/MM/YYYY');
        };

        const renderOwner = () => {
            if (this.state.editOwner) {
                return (
                    <Autocomplete
                        id="owner-autocomplete"
                        size={'small'}
                        open
                        className={classes.editCellAutocomplete}
                        options={this.state.owners || []}
                        loadingText={'Loading...'}
                        clearText="Close"
                        defaultValue={this.state?.customerLeadDetails?.owner}
                        getOptionLabel={option => option.displayName}
                        style={{ width: '95%' }}
                        onClose={() => {
                            this.setState({ editOwner: false });
                        }}
                        renderInput={params => (
                            <TextField {...params} label="" variant="outlined" className={classes.staffSelection} />
                        )}
                        onChange={(e, value) => {
                            if (!value) {
                                return false;
                            }
                            this.setState(
                                {
                                    customerLeadDetails: { ...this.state.customerLeadDetails, owner: value },
                                    editOwner: false
                                },
                                () => {
                                    this.saveCustomerLeadDetails();
                                }
                            );
                        }}
                    />
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editOwner: true });
                    }}
                >
                    <span>{this.state?.customerLeadDetails?.owner?.displayName || 'Select staff'}</span>
                </div>
            );
        };

        const renderPipelineStage = () => {
            if (this.state.editPipelineStage) {
                return (
                    <Autocomplete
                        id="leadStage-autocomplete"
                        size={'small'}
                        open
                        className={classes.editCellAutocomplete}
                        options={this.state.pipelineStages || []}
                        loadingText={'Loading...'}
                        clearText="Close"
                        defaultValue={this.state?.customerLeadDetails?.leadStage}
                        getOptionLabel={option => option.name}
                        style={{ width: '95%' }}
                        onClose={() => {
                            this.setState({ editPipelineStage: false });
                        }}
                        renderInput={params => (
                            <TextField {...params} label="" variant="outlined" className={classes.staffSelection} />
                        )}
                        onChange={(e, value) => {
                            if (!value) {
                                return false;
                            }
                            this.setState(
                                {
                                    customerLeadDetails: { ...this.state.customerLeadDetails, leadStage: value },
                                    editPipelineStage: false
                                },
                                () => {
                                    this.saveCustomerLeadDetails();
                                }
                            );
                        }}
                    />
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editPipelineStage: true });
                    }}
                >
                    <span>{this.state?.customerLeadDetails?.leadStage?.name || '-'}</span>
                </div>
            );
        };

        const renderServiceCell = (element, index) => {
            if (this.state.editServiceId === index) {
                return (
                    <Autocomplete
                        id="service-autocomplete"
                        size={'small'}
                        className={classes.editCellAutocomplete}
                        options={this.state.servicesOptions || []}
                        loadingText="Loading..."
                        clearText="Close"
                        defaultValue={element.service}
                        getOptionLabel={option => option.name}
                        style={{ width: '95%' }}
                        onClose={() => {
                            this.setState({ editServiceId: false });
                            if (!element?.service?.id) {
                                removeService(index);
                            }
                        }}
                        onInputChange={async (e, value) => {
                            await invoiceApi.getServices(value, 50, false, true).then(res => {
                                this.setState({
                                    servicesOptions: res.items
                                });
                            });
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label=""
                                variant="outlined"
                                className={classes.staffSelection}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon style={{ fontSize: 18, color: '#999' }} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                        onChange={(e, value) => {
                            if (!value) return false;
                            const leadServices = this.state.customerLeadDetails?.leadServices || [];
                            leadServices[index].service = value;
                            leadServices[index].value = value.defaultGrossPrice;
                            this.setState(
                                {
                                    customerLeadDetails: { ...this.state.customerLeadDetails, leadServices },
                                    editServiceId: null
                                },
                                () => {
                                    this.saveCustomerLeadDetails();
                                }
                            );
                        }}
                    />
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editServiceId: index });
                    }}
                >
                    <span>{element?.service?.name}</span>
                </div>
            );
        };

        const renderValueCell = (element, index) => {
            const getNumericValue = value => {
                if (!value) {
                    if (value === '') {
                        return value;
                    } else {
                        return 0;
                    }
                }

                return value;
            };
            if (this.state.editValueId === index) {
                return (
                    <>
                        <EditableCell
                            defaultValue={getNumericValue(element.value)}
                            toLeft={true}
                            onConfirm={value => {
                                const leadServices = this.state.customerLeadDetails?.leadServices || [];
                                leadServices[index].value = parseFloat(value);
                                this.setState({
                                    customerLeadDetails: { ...this.state.customerLeadDetails, leadServices },
                                    editValueId: null
                                });
                                this.saveCustomerLeadDetails();
                            }}
                            onCancel={() => {
                                this.setState({ editValueId: null });
                            }}
                        >
                            {({ value, setValue }) => (
                                <>
                                    <TextField
                                        className={classes.editCellInput}
                                        value={value}
                                        type="number"
                                        variant="outlined"
                                        onChange={event => {
                                            const value = event.target.value;

                                            if (+value < 0) {
                                                toastr.error('Error', 'This value cannot be negative');
                                            } else {
                                                setValue(value);
                                            }
                                        }}
                                    />
                                </>
                            )}
                        </EditableCell>
                    </>
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editValueId: index });
                    }}
                >
                    {toLocaleString(element.value)}
                </div>
            );
        };

        const removeService = index => {
            const leadServices = this.state?.customerLeadDetails?.leadServices;
            leadServices.splice(index, 1);
            this.setState({
                customerLeadDetails: {
                    ...this.state.customerLeadDetails,
                    leadServices
                }
            });
            this.saveCustomerLeadDetails();
        };

        const renderProductCell = (element, index) => {
            if (this.state.editProductId === index) {
                return (
                    <Autocomplete
                        id="product-autocomplete"
                        size={'small'}
                        className={classes.editCellAutocomplete}
                        options={this.state.productsOptions || []}
                        loadingText="Loading..."
                        clearText="Close"
                        defaultValue={element.product}
                        getOptionLabel={option => option.name}
                        style={{ width: '95%' }}
                        onClose={() => {
                            this.setState({ editProductId: false });
                            if (!element?.product?.id) {
                                removeProduct(index);
                            }
                        }}
                        onInputChange={async (e, value) => {
                            await invoiceApi.getProducts(value, 50).then(res => {
                                this.setState({
                                    productsOptions: res.items || res
                                });
                            });
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label=""
                                variant="outlined"
                                className={classes.staffSelection}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon style={{ fontSize: 18, color: '#999' }} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                        onChange={(e, value) => {
                            if (!value) return false;
                            const leadProducts = this.state.customerLeadDetails?.leadProducts || [];
                            leadProducts[index].product = value;
                            leadProducts[index].value = value.grossPrice ?? value.netPrice ?? 0;
                            this.setState(
                                {
                                    customerLeadDetails: { ...this.state.customerLeadDetails, leadProducts },
                                    editProductId: null
                                },
                                () => {
                                    this.saveCustomerLeadDetails();
                                }
                            );
                        }}
                    />
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editProductId: index });
                    }}
                >
                    <span>{element?.product?.name}</span>
                </div>
            );
        };

        const renderProductValueCell = (element, index) => {
            const getNumericValue = value => {
                if (!value) {
                    if (value === '') {
                        return value;
                    } else {
                        return 0;
                    }
                }
                return value;
            };
            if (this.state.editProductValueId === index) {
                return (
                    <EditableCell
                        defaultValue={getNumericValue(element.value)}
                        toLeft={true}
                        onConfirm={value => {
                            const leadProducts = this.state.customerLeadDetails?.leadProducts || [];
                            leadProducts[index].value = parseFloat(value);
                            this.setState({
                                customerLeadDetails: { ...this.state.customerLeadDetails, leadProducts },
                                editProductValueId: null
                            });
                            this.saveCustomerLeadDetails();
                        }}
                        onCancel={() => {
                            this.setState({ editProductValueId: null });
                        }}
                    >
                        {({ value, setValue }) => (
                            <TextField
                                className={classes.editCellInput}
                                value={value}
                                type="number"
                                variant="outlined"
                                onChange={event => {
                                    const value = event.target.value;
                                    if (+value < 0) {
                                        toastr.error('Error', 'This value cannot be negative');
                                    } else {
                                        setValue(value);
                                    }
                                }}
                            />
                        )}
                    </EditableCell>
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editProductValueId: index });
                    }}
                >
                    {toLocaleString(element.value)}
                </div>
            );
        };

        const removeProduct = index => {
            const leadProducts = this.state?.customerLeadDetails?.leadProducts || [];
            leadProducts.splice(index, 1);
            this.setState({
                customerLeadDetails: {
                    ...this.state.customerLeadDetails,
                    leadProducts
                }
            });
            this.saveCustomerLeadDetails();
        };

        const renderCourseCell = (element, index) => {
            if (this.state.editCourseId === index) {
                return (
                    <Autocomplete
                        id="course-autocomplete"
                        size={'small'}
                        className={classes.editCellAutocomplete}
                        options={this.state.coursesOptions || []}
                        loadingText="Loading..."
                        clearText="Close"
                        defaultValue={element.course}
                        getOptionLabel={option => option.name}
                        style={{ width: '95%' }}
                        onClose={() => {
                            this.setState({ editCourseId: false });
                            if (!element?.course?.id) {
                                removeCourse(index);
                            }
                        }}
                        onInputChange={async (e, value) => {
                            await invoiceApi.getCourses(value, 50).then(res => {
                                this.setState({
                                    coursesOptions: res
                                });
                            });
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label=""
                                variant="outlined"
                                className={classes.staffSelection}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon style={{ fontSize: 18, color: '#999' }} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                        onChange={(e, value) => {
                            if (!value) return false;
                            const leadCourses = this.state.customerLeadDetails?.leadCourses || [];
                            leadCourses[index].course = value;
                            leadCourses[index].value = value.grossPrice ?? value.netPrice ?? 0;
                            this.setState(
                                {
                                    customerLeadDetails: { ...this.state.customerLeadDetails, leadCourses },
                                    editCourseId: null
                                },
                                () => {
                                    this.saveCustomerLeadDetails();
                                }
                            );
                        }}
                    />
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editCourseId: index });
                    }}
                >
                    <span>{element?.course?.name}</span>
                </div>
            );
        };

        const renderCourseValueCell = (element, index) => {
            const getNumericValue = value => {
                if (!value) {
                    if (value === '') {
                        return value;
                    } else {
                        return 0;
                    }
                }
                return value;
            };
            if (this.state.editCourseValueId === index) {
                return (
                    <EditableCell
                        defaultValue={getNumericValue(element.value)}
                        toLeft={true}
                        onConfirm={value => {
                            const leadCourses = this.state.customerLeadDetails?.leadCourses || [];
                            leadCourses[index].value = parseFloat(value);
                            this.setState({
                                customerLeadDetails: { ...this.state.customerLeadDetails, leadCourses },
                                editCourseValueId: null
                            });
                            this.saveCustomerLeadDetails();
                        }}
                        onCancel={() => {
                            this.setState({ editCourseValueId: null });
                        }}
                    >
                        {({ value, setValue }) => (
                            <TextField
                                className={classes.editCellInput}
                                value={value}
                                type="number"
                                variant="outlined"
                                onChange={event => {
                                    const value = event.target.value;
                                    if (+value < 0) {
                                        toastr.error('Error', 'This value cannot be negative');
                                    } else {
                                        setValue(value);
                                    }
                                }}
                            />
                        )}
                    </EditableCell>
                );
            }

            return (
                <div
                    className={classes.editable}
                    onClick={() => {
                        this.setState({ editCourseValueId: index });
                    }}
                >
                    {toLocaleString(element.value)}
                </div>
            );
        };

        const removeCourse = index => {
            const leadCourses = this.state?.customerLeadDetails?.leadCourses || [];
            leadCourses.splice(index, 1);
            this.setState({
                customerLeadDetails: {
                    ...this.state.customerLeadDetails,
                    leadCourses
                }
            });
            this.saveCustomerLeadDetails();
        };

        return (
            <div className={classes.tabGroup}>
                {this.renderRedirect()}
                <Grid container direction="row">
                    <Grid item xs={12}>
                        <AppBar position="static" className={classes.whiteBar} classes={{ root: classes.noShadow }}>
                            <Tabs
                                variant="scrollable"
                                indicatorColor="primary"
                                classes={{ indicator: classes.tabIndicator }}
                                value={this.state.group || 'personal'}
                                onChange={(e, value) => this.setState({ redirect: true, group: value })}
                            >
                                <Tab value={'personal'} label="Personal" className={classes.tab} />
                                {!this.props.customer.isLead && (
                                    <Tab value={'gp_insurance'} label="GP/Insurance" className={classes.tab} />
                                )}
                                {!this.props.customer.isLead && (
                                    <Tab value={'saved_cards'} label="Saved Cards" className={classes.tab} />
                                )}
                                {this.props.organisation?.marketingDataEnabled && (
                                    <Tab value={'marketing_data'} label="Marketing Data" className={classes.tab} />
                                )}
                            </Tabs>
                        </AppBar>
                        {this.state.group === 'gp_insurance' && (
                            <div>
                                <Grid container>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <GPDetails
                                            customer={this.props.customer}
                                            updateGp={this.props.updateGp}
                                            reloadCustomer={this.props.reloadCustomer}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <InsuranceDetails customer={this.props.customer} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <KinOfEmergency customer={this.props.customer} />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        {this.props.organisation?.marketingDataEnabled && this.state.group === 'marketing_data' && (
                            <div>
                                <Grid container>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <CustomerMarketingData
                                            customer={this.props.customer}
                                            reloadCustomer={this.props.reloadCustomer}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        {this.state.group === 'saved_cards' && (
                            <div>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <SavedCards customer={this.props.customer} />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        {/* Marketing tab removed - photo consent moved to Personal, campaign fields to Marketing Data */}
                        {this.state.group === 'personal' && (
                            <Grid container direction="row" alignItems="flex-start">
                                <Grid
                                    item
                                    xs={
                                        (this.state.customerOverall && !this.props.customer.isLead && !infoHidden) ||
                                        (this.state.customerLeadDetails && this.props.customer.isLead)
                                            ? 8
                                            : 12
                                    }
                                >
                                    <CustomerPersonal customer={this.props.customer} />
                                </Grid>
                                {this.state.customerOverall && !this.props.customer.isLead && !infoHidden && (
                                    <Grid item xs={4}>
                                        <Card>
                                            <Box p={5}>
                                                <Grid container direction="row" justify="center">
                                                    <Grid item container justify="space-between" alignItems="center">
                                                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant="h3">Total Sale: </Typography>
                                                            <Tooltip
                                                                title={
                                                                    <span style={{ fontSize: 14 }}>
                                                                        Total sale is the sum of all invoices excluding
                                                                        account and gift voucher purchases. Ie it is the
                                                                        sum of sales invoices but ignoring account and
                                                                        gift vouchers as these are not true sales -
                                                                        these are funds held on account to be spent at a
                                                                        later date.
                                                                    </span>
                                                                }
                                                            >
                                                                <HelpIcon style={{ fontSize: 14, cursor: 'pointer' }} />
                                                            </Tooltip>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography variant="h2" className={classes.bold}>
                                                                {toLocaleString(this.getTotalSpend())}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="center"
                                                    style={{ marginTop: 8 }}
                                                >
                                                    <Grid item container justify="space-between" alignItems="center">
                                                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant="h3">Total Paid: </Typography>
                                                            <Tooltip
                                                                title={
                                                                    <span style={{ fontSize: 14 }}>
                                                                        Total paid is the sum of all payments excluding
                                                                        those for account and gift voucher purchases. Ie
                                                                        it is the sum of payments received but ignoring
                                                                        account and gift voucher payments as these are
                                                                        funds held on account to be spent at a later
                                                                        date.
                                                                    </span>
                                                                }
                                                            >
                                                                <HelpIcon style={{ fontSize: 14, cursor: 'pointer' }} />
                                                            </Tooltip>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography variant="h2" className={classes.bold}>
                                                                {toLocaleString(
                                                                    this.state.customerOverall?.liveTotalPaid || 0
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="center"
                                                    style={{ marginTop: 8 }}
                                                >
                                                    <Grid item container justify="space-between" alignItems="center">
                                                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant="h3">Account/Gift Voucher: </Typography>
                                                            <Tooltip
                                                                title={
                                                                    <span style={{ fontSize: 14 }}>
                                                                        This number is the amount of money on account
                                                                        plus any unused gift voucher balance. Please
                                                                        note, the purchase of a gift voucher does not
                                                                        automatically add to the gift voucher balance.
                                                                        It will only be added if a gift voucher is used
                                                                        and there is remaining balance. See the help
                                                                        article &quot;How gift vouchers work&quot;.
                                                                    </span>
                                                                }
                                                            >
                                                                <HelpIcon style={{ fontSize: 14, cursor: 'pointer' }} />
                                                            </Tooltip>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography variant="h2" className={classes.bold}>
                                                                {toLocaleString(
                                                                    (this.state.customerOverall?.accountBalance || 0) +
                                                                        (this.state.customerOverall
                                                                            ?.giftVoucherBalance || 0)
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container style={{ marginTop: 16 }} direction="column">
                                                    <Grid item container direction="column">
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Ave sale:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {toLocaleString(
                                                                    this.state.customerOverall.avgSpend
                                                                        ? this.state.customerOverall.avgSpend
                                                                        : 0
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Ave service sale:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {toLocaleString(
                                                                    this.state.customerOverall.avgServiceSpend || 0
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Ave product sale:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {toLocaleString(
                                                                    this.state.customerOverall.avgProductSpend || 0
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Ave course sale:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {toLocaleString(
                                                                    this.state.customerOverall.avgCourseSpend || 0
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                % bought product:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {this.state.customerOverall.productPercentage
                                                                    ? `${this.state.customerOverall.productPercentage.toFixed(
                                                                          2
                                                                      )} %`
                                                                    : '0 %'}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container direction="column">
                                                        <Divider className={classes.divider}></Divider>
                                                        <Grid item container direction="column">
                                                            <Grid
                                                                item
                                                                container
                                                                direction="row"
                                                                justify="space-between"
                                                            >
                                                                <Typography style={{ fontSize: 14 }} variant="h4">
                                                                    Favourite practitioner:
                                                                </Typography>
                                                                <Typography style={{ fontSize: 14 }} variant="h4">
                                                                    {this.state.customerOverall.favoritePractitioner ? (
                                                                        `${this.state.customerOverall.favoritePractitioner.firstName} ${this.state.customerOverall.favoritePractitioner.surname}`
                                                                    ) : (
                                                                        <span style={{ marginRight: '2px' }}>-</span>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                container
                                                                direction="row"
                                                                justify="space-between"
                                                            >
                                                                <Typography style={{ fontSize: 14 }} variant="h4">
                                                                    Favourite treatment cat:
                                                                </Typography>
                                                                <Typography style={{ fontSize: 14 }} variant="h4">
                                                                    {this.state.customerOverall
                                                                        .mostCommonTreatmentCategory ? (
                                                                        this.state.customerOverall
                                                                            .mostCommonTreatmentCategory.category.name
                                                                    ) : (
                                                                        <span style={{ marginRight: '2px' }}>-</span>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction="column">
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Total visits:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {this.state.customerOverall.totalVisits}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                First visit:
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {this.state.customerOverall.firstVisit ? (
                                                                    getDataFormat(this.state.customerOverall.firstVisit)
                                                                ) : (
                                                                    <span style={{ marginRight: '2px' }}>-</span>
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item container direction="row" justify="space-between">
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                Last visit
                                                            </Typography>
                                                            <Typography style={{ fontSize: 14 }} variant="h4">
                                                                {this.state.customerOverall.lastVisit ? (
                                                                    getDataFormat(this.state.customerOverall.lastVisit)
                                                                ) : (
                                                                    <span style={{ marginRight: '2px' }}>-</span>
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Card>
                                    </Grid>
                                )}
                                {this.state.customerLeadDetails && this.props.customer.isLead && (
                                    <Grid item xs={4}>
                                        <Card>
                                            <Box p={5}>
                                                <Grid container spacing={2}>
                                                    <Grid item container spacing={2}>
                                                        <Grid item xs={2}>
                                                            <Grid item>
                                                                <Typography className={classes.sectionLabel}>
                                                                    Pipeline
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <div className={classes.noneditable}>
                                                                    <span>
                                                                        {this.state.customerLeadDetails?.leadPipeline
                                                                            ?.name
                                                                            ? this.state.customerLeadDetails
                                                                                  ?.leadPipeline?.name
                                                                            : ''}
                                                                    </span>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Grid item>
                                                                <Typography className={classes.sectionLabel}>
                                                                    Stage
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>{renderPipelineStage()}</Grid>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Grid item>
                                                                <Typography className={classes.sectionLabel}>
                                                                    Owner
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>{renderOwner()}</Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Table
                                                            className={classes.servicesTable}
                                                            size="medium"
                                                            stickyHeader
                                                        >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Select services</TableCell>
                                                                    <TableCell>Value</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(
                                                                    this.state?.customerLeadDetails?.leadServices || []
                                                                )?.map((element, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={`${index}-payment-table`}
                                                                            className={classes.tableRow}
                                                                        >
                                                                            <TableCell>
                                                                                {renderServiceCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {renderValueCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <IconButton
                                                                                    onClick={() => {
                                                                                        removeService(index);
                                                                                    }}
                                                                                >
                                                                                    <DeleteOutlineOutlinedIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                        <IconButton
                                                            onClick={async () => {
                                                                this.setState({
                                                                    servicesOptions: this.state.defaultServicesOptions
                                                                });
                                                                const leadServices = this.state?.customerLeadDetails
                                                                    ?.leadServices;
                                                                if (
                                                                    leadServices.filter(el => el.service.id === null)
                                                                        .length
                                                                ) {
                                                                    return false;
                                                                }
                                                                leadServices.push({
                                                                    service: {
                                                                        id: null,
                                                                        name: ''
                                                                    },
                                                                    value: 0
                                                                });
                                                                this.setState({
                                                                    customerLeadDetails: {
                                                                        ...this.state.customerLeadDetails,
                                                                        leadServices
                                                                    },
                                                                    editServiceId: leadServices.length - 1
                                                                });
                                                            }}
                                                        >
                                                            <AddCircleIcon style={{ color: '#3083EC' }} />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Table
                                                            className={classes.servicesTable}
                                                            size="medium"
                                                            stickyHeader
                                                        >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Select courses</TableCell>
                                                                    <TableCell>Value</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(
                                                                    this.state?.customerLeadDetails?.leadCourses || []
                                                                )?.map((element, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={`${index}-course-table`}
                                                                            className={classes.tableRow}
                                                                        >
                                                                            <TableCell>
                                                                                {renderCourseCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {renderCourseValueCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <IconButton
                                                                                    onClick={() => {
                                                                                        removeCourse(index);
                                                                                    }}
                                                                                >
                                                                                    <DeleteOutlineOutlinedIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                        <IconButton
                                                            onClick={async () => {
                                                                this.setState({
                                                                    coursesOptions: this.state.defaultCoursesOptions
                                                                });
                                                                const leadCourses =
                                                                    this.state?.customerLeadDetails?.leadCourses || [];
                                                                if (
                                                                    leadCourses.filter(el => el.course.id === null)
                                                                        .length
                                                                ) {
                                                                    return false;
                                                                }
                                                                leadCourses.push({
                                                                    course: {
                                                                        id: null,
                                                                        name: ''
                                                                    },
                                                                    value: 0
                                                                });
                                                                this.setState({
                                                                    customerLeadDetails: {
                                                                        ...this.state.customerLeadDetails,
                                                                        leadCourses
                                                                    },
                                                                    editCourseId: leadCourses.length - 1
                                                                });
                                                            }}
                                                        >
                                                            <AddCircleIcon style={{ color: '#3083EC' }} />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Table
                                                            className={classes.servicesTable}
                                                            size="medium"
                                                            stickyHeader
                                                        >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Select products</TableCell>
                                                                    <TableCell>Value</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(
                                                                    this.state?.customerLeadDetails?.leadProducts || []
                                                                )?.map((element, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={`${index}-product-table`}
                                                                            className={classes.tableRow}
                                                                        >
                                                                            <TableCell>
                                                                                {renderProductCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {renderProductValueCell(element, index)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <IconButton
                                                                                    onClick={() => {
                                                                                        removeProduct(index);
                                                                                    }}
                                                                                >
                                                                                    <DeleteOutlineOutlinedIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                        <IconButton
                                                            onClick={async () => {
                                                                this.setState({
                                                                    productsOptions: this.state.defaultProductsOptions
                                                                });
                                                                const leadProducts =
                                                                    this.state?.customerLeadDetails?.leadProducts || [];
                                                                if (
                                                                    leadProducts.filter(el => el.product.id === null)
                                                                        .length
                                                                ) {
                                                                    return false;
                                                                }
                                                                leadProducts.push({
                                                                    product: {
                                                                        id: null,
                                                                        name: ''
                                                                    },
                                                                    value: 0
                                                                });
                                                                this.setState({
                                                                    customerLeadDetails: {
                                                                        ...this.state.customerLeadDetails,
                                                                        leadProducts
                                                                    },
                                                                    editProductId: leadProducts.length - 1
                                                                });
                                                            }}
                                                        >
                                                            <AddCircleIcon style={{ color: '#3083EC' }} />
                                                        </IconButton>
                                                        {((this.state?.customerLeadDetails?.leadServices || []).length >
                                                            0 ||
                                                            (this.state?.customerLeadDetails?.leadProducts || [])
                                                                .length > 0 ||
                                                            (this.state?.customerLeadDetails?.leadCourses || [])
                                                                .length > 0) && (
                                                            <Typography className={classes.leadValue}>
                                                                Lead value £
                                                                {(
                                                                    (
                                                                        this.state?.customerLeadDetails?.leadServices ||
                                                                        []
                                                                    ).reduce((sum, s) => sum + (s.value || 0), 0) +
                                                                    (
                                                                        this.state?.customerLeadDetails?.leadProducts ||
                                                                        []
                                                                    ).reduce((sum, p) => sum + (p.value || 0), 0) +
                                                                    (
                                                                        this.state?.customerLeadDetails?.leadCourses ||
                                                                        []
                                                                    ).reduce((sum, c) => sum + (c.value || 0), 0)
                                                                ).toFixed(2)}
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                    {/*<Grid item xs={12}>*/}
                                                    {/*    <Grid container spacing={2} justifyContent="center">*/}
                                                    {/*        <Grid item>*/}
                                                    {/*            <Button*/}
                                                    {/*                variant="contained"*/}
                                                    {/*                style={{*/}
                                                    {/*                    ...(this.props.customer.leadStatus === LEAD_STATUS.WON*/}
                                                    {/*                        ? { backgroundColor: 'green', color: '#fff' }*/}
                                                    {/*                        : { backgroundColor: 'white', color: '#888' }),*/}
                                                    {/*                    width: 100*/}
                                                    {/*                }}*/}
                                                    {/*                onClick={async () => {*/}
                                                    {/*                    if (this.props.customer.leadStatus === LEAD_STATUS.WON) {*/}
                                                    {/*                        await customerApi*/}
                                                    {/*                            .updateCustomerLeadStatus(*/}
                                                    {/*                                this.props.customer.id,*/}
                                                    {/*                                LEAD_STATUS.OPEN*/}
                                                    {/*                            )*/}
                                                    {/*                            .then(res => {*/}
                                                    {/*                                this.setState({*/}
                                                    {/*                                    leadCustomer: res.data.customer*/}
                                                    {/*                                });*/}
                                                    {/*                                this.props.reloadCustomer(*/}
                                                    {/*                                    this.props.customer.id*/}
                                                    {/*                                );*/}
                                                    {/*                            });*/}
                                                    {/*                        return;*/}
                                                    {/*                    } else {*/}
                                                    {/*                        await customerApi*/}
                                                    {/*                            .updateCustomerLeadStatus(*/}
                                                    {/*                                this.props.customer.id,*/}
                                                    {/*                                LEAD_STATUS.WON*/}
                                                    {/*                            )*/}
                                                    {/*                            .then(res => {*/}
                                                    {/*                                this.setState({*/}
                                                    {/*                                    leadCustomer: res.data.customer*/}
                                                    {/*                                });*/}
                                                    {/*                                this.props.reloadCustomer(*/}
                                                    {/*                                    this.props.customer.id*/}
                                                    {/*                                );*/}

                                                    {/*                                if (*/}
                                                    {/*                                    this.state?.leadCustomer?.id &&*/}
                                                    {/*                                    (this.props.customer.firstName !==*/}
                                                    {/*                                        this.state?.leadCustomer?.firstName ||*/}
                                                    {/*                                        this.props.customer.surname !==*/}
                                                    {/*                                            this.state.leadCustomer?.surname)*/}
                                                    {/*                                ) {*/}
                                                    {/*                                    toastr.warning(*/}
                                                    {/*                                        'Client already exists with this email and same first or surname'*/}
                                                    {/*                                    );*/}
                                                    {/*                                    return;*/}
                                                    {/*                                }*/}
                                                    {/*                                if (*/}
                                                    {/*                                    !this.state?.leadCustomer?.id ||*/}
                                                    {/*                                    this.state?.leadCustomer?.archived*/}
                                                    {/*                                ) {*/}
                                                    {/*                                    this.setState({*/}
                                                    {/*                                        isChangeLeadStatusConfirmModalOpen: true*/}
                                                    {/*                                    });*/}
                                                    {/*                                }*/}
                                                    {/*                            });*/}
                                                    {/*                    }*/}
                                                    {/*                }}*/}
                                                    {/*            >*/}
                                                    {/*                Won*/}
                                                    {/*            </Button>*/}
                                                    {/*        </Grid>*/}
                                                    {/*        <Grid item>*/}
                                                    {/*            <Button*/}
                                                    {/*                variant="contained"*/}
                                                    {/*                style={{*/}
                                                    {/*                    ...(this.props.customer.leadStatus === LEAD_STATUS.LOST*/}
                                                    {/*                        ? { backgroundColor: 'red', color: '#fff' }*/}
                                                    {/*                        : { backgroundColor: 'white', color: '#888' }),*/}
                                                    {/*                    width: 100*/}
                                                    {/*                }}*/}
                                                    {/*                onClick={async () => {*/}
                                                    {/*                    if (this.props.customer.leadStatus === LEAD_STATUS.LOST) {*/}
                                                    {/*                        await customerApi*/}
                                                    {/*                            .updateCustomerLeadStatus(*/}
                                                    {/*                                this.props.customer.id,*/}
                                                    {/*                                LEAD_STATUS.OPEN*/}
                                                    {/*                            )*/}
                                                    {/*                            .then(res => {*/}
                                                    {/*                                this.setState({*/}
                                                    {/*                                    leadCustomer: res.data.customer*/}
                                                    {/*                                });*/}
                                                    {/*                                this.props.reloadCustomer(*/}
                                                    {/*                                    this.props.customer.id*/}
                                                    {/*                                );*/}
                                                    {/*                            });*/}
                                                    {/*                        return;*/}
                                                    {/*                    }*/}

                                                    {/*                    await customerApi*/}
                                                    {/*                        .updateCustomerLeadStatus(*/}
                                                    {/*                            this.props.customer.id,*/}
                                                    {/*                            LEAD_STATUS.LOST*/}
                                                    {/*                        )*/}
                                                    {/*                        .then(res => {*/}
                                                    {/*                            this.setState({*/}
                                                    {/*                                leadCustomer: res.data.customer*/}
                                                    {/*                            });*/}
                                                    {/*                            this.props.reloadCustomer(this.props.customer.id);*/}
                                                    {/*                        });*/}
                                                    {/*                }}*/}
                                                    {/*            >*/}
                                                    {/*                Lost*/}
                                                    {/*            </Button>*/}
                                                    {/*        </Grid>*/}
                                                    {/*    </Grid>*/}
                                                    {/*    <Grid container spacing={2} justifyContent="center">*/}
                                                    {/*        <Grid item style={{ fontSize: 14 }}>*/}
                                                    {/*            Lead status*/}
                                                    {/*        </Grid>*/}
                                                    {/*    </Grid>*/}
                                                    {/*</Grid>*/}
                                                    <Grid item xs={12}>
                                                        <Grid
                                                            container
                                                            spacing={2}
                                                            justifyContent="center"
                                                            style={{ marginTop: 35 }}
                                                        >
                                                            <Grid item>
                                                                <Button
                                                                    variant="contained"
                                                                    disabled={this.state?.leadCustomer?.id}
                                                                    style={
                                                                        !this.state?.leadCustomer?.id
                                                                            ? {
                                                                                  backgroundColor: '#3083EC',
                                                                                  color: '#fff',
                                                                                  textTransform: 'none'
                                                                              }
                                                                            : { textTransform: 'none' }
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            this.state?.leadCustomer?.id &&
                                                                            (this.props.customer.firstName !==
                                                                                this.state?.leadCustomer?.firstName ||
                                                                                this.props.customer.surname !==
                                                                                    this.state.leadCustomer?.surname)
                                                                        ) {
                                                                            toastr.warning(
                                                                                'Client already exists with this email and same first or surname'
                                                                            );
                                                                            return;
                                                                        }
                                                                        this.setState({
                                                                            isCreateCustomerConfirmModalOpen: true
                                                                        });
                                                                    }}
                                                                >
                                                                    Create client
                                                                </Button>
                                                            </Grid>
                                                            <Grid item>
                                                                <Button
                                                                    variant="contained"
                                                                    style={
                                                                        this.state?.leadCustomer?.id
                                                                            ? {
                                                                                  backgroundColor: '#3083EC',
                                                                                  color: '#fff',
                                                                                  textTransform: 'none'
                                                                              }
                                                                            : { textTransform: 'none' }
                                                                    }
                                                                    disabled={!this.state?.leadCustomer?.id}
                                                                    onClick={() => {
                                                                        window.open(
                                                                            `${
                                                                                JSON.parse(
                                                                                    localStorage.getItem('linkCache')
                                                                                ).calendarUrl
                                                                            }/?day=${new moment().format(
                                                                                'DD-MM-YYYY'
                                                                            )}&customer=${
                                                                                this.state?.leadCustomer?.id
                                                                            }&lead=${this.props.customer.id}`,
                                                                            '_blank'
                                                                        );
                                                                    }}
                                                                >
                                                                    Book appt
                                                                </Button>
                                                            </Grid>
                                                            <Grid item>
                                                                <Button
                                                                    variant="contained"
                                                                    style={
                                                                        this.state?.leadCustomer?.id
                                                                            ? {
                                                                                  backgroundColor: '#3083EC',
                                                                                  color: '#fff',
                                                                                  textTransform: 'none'
                                                                              }
                                                                            : { textTransform: 'none' }
                                                                    }
                                                                    disabled={!this.state?.leadCustomer?.id}
                                                                    onClick={() => {
                                                                        window.open(
                                                                            `${
                                                                                JSON.parse(
                                                                                    localStorage.getItem('linkCache')
                                                                                ).posUrl
                                                                            }/sale?customer=${
                                                                                this.state.leadCustomer.id
                                                                            }&lead=${this.props.customer.id}`,
                                                                            '_blank'
                                                                        );
                                                                    }}
                                                                >
                                                                    Create invoice
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Card>
                                    </Grid>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {this.state.isLoading && <LoadingScreen />}
                {this.state.isChangeLeadStatusConfirmModalOpen && (
                    <CancelContinueModal
                        setOpen={() => {
                            this.setState({ isChangeLeadStatusConfirmModalOpen: false });
                        }}
                        onContinue={async () => {
                            if (!this.state?.leadCustomer?.id) {
                                this.setState({
                                    isChangeLeadStatusConfirmModalOpen: false,
                                    isCreateClientFormOpen: true,
                                    createClientStatusAfterSave: LEAD_STATUS.WON
                                });
                            } else {
                                await customerApi
                                    .updateCustomerLeadStatus(this.props.customer.id, LEAD_STATUS.WON, false)
                                    .then(res => {
                                        this.setState({
                                            leadCustomer: res.data.customer
                                        });
                                        this.props.reloadCustomer(this.props.customer.id);
                                        if (this.state?.leadCustomer?.archived) {
                                            toastr.success('Client unarchived');
                                        }
                                    });
                            }
                        }}
                        closeOnBlur={false}
                        title={
                            this.state?.leadCustomer?.archived ? 'Unarchive client' : 'Create client from this lead?'
                        }
                        contentText={
                            !this.state?.leadCustomer?.id
                                ? 'You have updated the Lead status to Won.\n' +
                                  'Would you like to create a client from this lead?'
                                : this.state?.leadCustomer?.archived
                                ? 'Customer already exists but is archived. Do you want to unarchive customer?'
                                : 'Lead status will be changed to won'
                        }
                        continueButtonText={
                            this.state?.leadCustomer?.archived ? 'Yes, unarchive' : 'Yes, create new client'
                        }
                        cancelButtonText={'No'}
                    />
                )}
                {this.state.isCreateCustomerConfirmModalOpen && (
                    <CancelContinueModal
                        setOpen={() => {
                            this.setState({ isCreateCustomerConfirmModalOpen: false });
                        }}
                        onContinue={async () => {
                            if (!this.state?.leadCustomer?.id) {
                                this.setState({
                                    isCreateCustomerConfirmModalOpen: false,
                                    isCreateClientFormOpen: true,
                                    createClientStatusAfterSave: null
                                });
                            } else {
                                await customerApi
                                    .updateCustomerLeadStatus(this.props.customer.id, null, false)
                                    .then(res => {
                                        this.setState({
                                            leadCustomer: res.data.customer
                                        });
                                        this.props.reloadCustomer(this.props.customer.id);
                                        toastr.success('Client unarchived');
                                    });
                            }
                        }}
                        closeOnBlur={false}
                        title="Create client from lead"
                        contentText={
                            !this.state?.leadCustomer?.id
                                ? 'A new client will be created so that you can book appointments etc. This lead will not be deleted.'
                                : 'Customer already exists but is archived. Customer will be unarchived'
                        }
                    />
                )}
                {this.state.isCreateClientFormOpen && (
                    <CreateCustomerModal
                        isCreateCustomerModalOpen={true}
                        isCreateCustomerModalAllowLead={false}
                        isCreateCustomerModalAllowCustomer={true}
                        hideCreateCustomerModal={() => {
                            this.setState({ isCreateClientFormOpen: false });
                        }}
                        persistCustomer={async (data, file, clinic) => {
                            try {
                                const result = await customerApi.postCustomer({
                                    ...data,
                                    addAsLead: false,
                                    fromLead: this.props.customer.id,
                                    leadConvertedAt: new Date(),
                                    clinics: clinic ? [clinic] : undefined
                                });
                                if (file && result.data?.id) {
                                    await uploadCustomerAvatar(result.data.id, file);
                                }
                                const statusToSet = this.state.createClientStatusAfterSave;
                                if (statusToSet) {
                                    await customerApi.updateCustomerLeadStatus(
                                        this.props.customer.id,
                                        statusToSet,
                                        false
                                    );
                                }
                                this.setState({
                                    leadCustomer: result.data
                                });
                                this.props.reloadCustomer(this.props.customer.id);
                                toastr.success('Client created');
                            } catch (err) {
                                toastr.error(err?.response?.data?.message || 'Failed to create client');
                                return err;
                            }
                        }}
                        reloadCustomerList={() => {}}
                        clinic={localStorage.getItem('currentClinic')}
                        initialCustomerData={{
                            firstName: this.props.customer.firstName,
                            surname: this.props.customer.surname,
                            middleName: this.props.customer.middleName,
                            email: this.props.customer.email || this.props.customer.leadEmail,
                            dateOfBirth: this.props.customer.dateOfBirth,
                            mobilePhone: this.props.customer.mobilePhone,
                            otherPhone: this.props.customer.otherPhone,
                            title: this.props.customer.title,
                            gender: this.props.customer.gender,
                            address1: this.props.customer.address1,
                            address2: this.props.customer.address2,
                            city: this.props.customer.city,
                            county: this.props.customer.county,
                            country: this.props.customer.country,
                            postal: this.props.customer.postal || this.props.customer.postCode,
                            referralSource: this.props.customer.referralSource,
                            referredBy: this.props.customer.referredBy,
                            prevSurname: this.props.customer.prevSurname,
                            aka: this.props.customer.aka,
                            ethnicity: this.props.customer.ethnicity,
                            nhsNumber: this.props.customer.nhsNumber,
                            passportId: this.props.customer.passportId,
                            occupation: this.props.customer.occupation,
                            height: this.props.customer.height,
                            weight: this.props.customer.weight
                        }}
                    />
                )}
            </div>
        );
    }
}

CustomerGeneral.propTypes = {
    classes: PropTypes.object.isRequired,
    customer: PropTypes.object,
    infoHidden: PropTypes.bool,
    updateGp: PropTypes.func,
    updateInsurance: PropTypes.func,
    reloadCustomer: PropTypes.func,
    route: PropTypes.object,
    organisation: PropTypes.object
};

export default withStyles(styles)(CustomerGeneral);
